<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <e-items>
        <e-item v-if='btns.refresh' prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Track.refreshTask")' :click='buttonClk' operate='refresh'></e-item>
        <e-item v-if='btns.add' prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Track.addTask")' :click='buttonClk' operate='add'></e-item>
        <e-item v-if='btns.active' prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("Track.activationTask")' :click='buttonClk' operate='active'></e-item>
        <e-item v-if='btns.hangup'  prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("Track.suspendTask")' :click='buttonClk' operate='hangup'></e-item>
        <e-item v-if='btns.finish' prefixIcon='icon hero-icon hero-icon-confirm' :tooltipText='$t("Track.missionCompleted")' :click='buttonClk' operate='finish'></e-item>
        <e-item v-if='btns.delete' prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Track.taskDeletion")' :click='buttonClk' operate='delete'></e-item>
        <e-item v-if='btns.detail' prefixIcon='icon hero-icon hero-icon-details' :tooltipText='$t("Track.taskDetails")' :click='buttonClk' operate='detail'></e-item>
        <e-item v-if='btns.mission' prefixIcon='icon hero-icon hero-icon-task-tracking' :tooltipText='$t("Track.taskTracking")' :click='buttonClk' operate='mission'></e-item>
        <e-item v-if='btns.download' prefixIcon='icon hero-icon hero-icon-download' :tooltipText='$t("Track.downloadFile")' :click='buttonClk' operate='download'></e-item>
      </e-items>
    </ejs-toolbar>
    <div v-if='btns.keywordsInput' class='h-inputBox'>
      <ejs-textbox v-model='queryConditions.keywords' :placeholder='$t("Track.pleaseEnterQuery")' @keydown.native='updateKeywords'></ejs-textbox>
    </div>
  </div>
</template>

<script>
import bus from '../bus.js';
export default {
  name: 'TrackTableMenu',
  data() {
    return {
      btns: {
        refresh: true,
        add: true,
        active: true,
        stop: true,
        hangup: true,
        finish: true,
        delete: true,
        detail: true,
        mission: true,
        download: true,
        keywordsInput: true
      },
      queryConditions: {
        keywords: '', // 模糊查询关键字
      }
    };
  },
  mounted() {
    bus.$on('loadTrackTable', (neNode) => {
      this.queryConditions.keywords = '';
    });
  },
  methods: {
    buttonClk(args) {
      if (args.item.operate === 'refresh') {
        this.queryConditions.keywords = '';
      }
      this.$emit('methodEnum', args.item.operate);
    },
    updateKeywords(clickEvent) {
      if (clickEvent.keyCode === 13) {
        this.$emit('keywords', this.queryConditions.keywords.trim());
      }
    }
  },
  beforeDestroy() {
    bus.$off('loadTrackTable');
  }
};
</script>
